

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23","height":"26"}, rest), [h('g', {"fill":"#FFF","fill-rule":"evenodd"}, [h('path', {"d":"M0 0h8v26H0zM15 0h8v26h-8z"}, [])])]);
};

        